import { Theme } from '@mui/material';

export const svgBlankStyle = (theme: Theme, size: number, disabled?: boolean) => {
  return {
    fontSize: `${size}px`,
    fill: disabled ? theme.palette.primary[40] : 'transparent',
    color: disabled ? theme.palette.primary[40] : theme.palette.primary[50],
  };
};

export const svgCheckedStyle = (theme: Theme, size: number, disabled?: boolean) => {
  return {
    fontSize: `${size}px`,
    fill: disabled ? theme.palette.primary[40] : theme.palette.secondary.main,
    '> path': {
      fill: theme.palette.common.white,
    },
  };
};

export const svgIndeterminateStyle = (theme: Theme, size: number, disabled?: boolean) => {
  return {
    fontSize: `${size}px`,
    fill: disabled ? theme.palette.primary[40] : theme.palette.secondary.main,
    '> path': {
      fill: theme.palette.common.white,
    },
  };
};
